import { makeActionCreator } from '../../config/store/utils'
import { getSmallerCompaniesParticipation } from '../../services/smallerCompanies'

export const GET_SMALLER_COMPANIES_PARTICIPATION = 'GET_SMALLER_COMPANIES_PARTICIPATION'
export const GET_SMALLER_COMPANIES_PARTICIPATION_ERROR = 'GET_SMALLER_COMPANIES_PARTICIPATION_ERROR'
export const GET_SMALLER_COMPANIES_PARTICIPATION_SUCCESS = 'GET_SMALLER_COMPANIES_PARTICIPATION_SUCCESS'

export const onGetSmallerCompaniesParticipation = makeActionCreator(GET_SMALLER_COMPANIES_PARTICIPATION)
export const onGetSmallerCompaniesParticipationError = makeActionCreator(
  GET_SMALLER_COMPANIES_PARTICIPATION_ERROR,
  'payload'
)
export const onGetSmallerCompaniesParticipationSuccess = makeActionCreator(
  GET_SMALLER_COMPANIES_PARTICIPATION_SUCCESS,
  'payload'
)

export const onGetSmallerCompaniesParticipationThunk = () => async dispatch => {
  dispatch(onGetSmallerCompaniesParticipation())
  try {
    const response = await getSmallerCompaniesParticipation()

    const data = response.data.payload

    const enhancedData = data.map(item => ({
      year: item.anio,
      quantityOffersEMT: item.cantidadOfertasEMT,
      quantityOffersTotals: item.cantidadOfertasTotales,
      percentageOffersEMT: item.porcentajeOfertasEMT,

      quantityAgilePurchaseQuotesEMT: item.cantidadCotizacionesCompraAgilEMT,
      quantityAgilePurchaseQuotesTotals: item.cantidadCotizacionesTotalesCompraAgil,
      percentageAgilePurchaseQuotesEMT: item.porcentajeCotizacionesCompraAgilEMT,

      quantityPurchaseOrdersEMT: item.cantidadOrdenesCompraEMT,
      quantityPurchaseOrdersTotals: item.cantidadOrdenesCompraTotales,
      percentageQuantityOrdersPurchaseEMT: item.porcentajeCantidadOrdenesCompraEMT,

      quantityEMTParticipating: item.cantidadEMTParticipando,
      quantityTotalParticipatingCompanies: item.cantidadTotalEmpresasParticipando,
      percentageEMTParticipating: item.porcentajeParticipacionEMT
    }))

    const csv = [
      [
        'Año',
        'Cantidad Ofertas EMT',
        'Cantidad Ofertas Totales',
        'Porcentaje Ofertas EMT',
        'Cantidad Cotizaciones Compra Agil EMT',
        'Cantidad Cotizaciones Totales Compra Agil',
        'Porcentaje Cotizaciones Compra Agil EMT',
        'Cantidad Órdenes Compra EMT',
        'Cantidad Órdenes Compra Totales',
        'Porcentaje Cantidad Órdenes Compra EMT',
        'Cantidad EMT Participación',
        'Cantidad Total Empresas Participación',
        'Porcentaje Participación EMT'
      ],
      ...enhancedData.map(d => [
        d.year,
        d.quantityOffersEMT,
        d.quantityOffersTotals,
        d.percentageOffersEMT,
        d.quantityAgilePurchaseQuotesEMT,
        d.quantityAgilePurchaseQuotesTotals,
        d.percentageAgilePurchaseQuotesEMT,
        d.quantityPurchaseOrdersEMT,
        d.quantityPurchaseOrdersTotals,
        d.percentageQuantityOrdersPurchaseEMT,
        d.quantityEMTParticipating,
        d.quantityTotalParticipatingCompanies,
        d.percentageEMTParticipating
      ])
    ]

    dispatch(onGetSmallerCompaniesParticipationSuccess({ data: enhancedData, csv }))
  } catch (error) {
    dispatch(onGetSmallerCompaniesParticipationError({ error: 'Error al obtener datos', data: [], csv: [] }))
  }
}
